import React from "react";
import { storyblokEditable } from "gatsby-source-storyblok"
import Background from "../parts/background/background"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper/modules"
import Image from "../../components/image/image"
import { ProcessLink } from "../../global/helpers"
import AfterContent from "../parts/after_content/after_content.js"
import BeforeContent from "../parts/before_content/before_content.js"

const QuoteComponent = ({ quote }) => {
    switch (quote.component) {
        case 'person_quote_component':
            return (
                <>
                    <div className="slide-inner person">
                        <span className="bracket left"></span>
                        {typeof quote.image[0].image !== 'undefined' &&
                            <Image blok={{ image: quote.image[0].image }} />
                        }
                        <figure className="quote-content">
                            <blockquote>
                                &ldquo;
                                {quote.quote_text}
                                &rdquo;
                            </blockquote>
                            <figcaption>
                                {typeof quote.author_name !== 'undefined' &&
                                    <strong>{quote.author_name}</strong>
                                }
                                {typeof quote.author_title !== 'undefined' &&
                                    <span className="title">{quote.author_title + ", "}</span>
                                }
                                {typeof quote.author_company !== 'undefined' &&
                                    <span className="company">{quote.author_company}</span>
                                }
                            </figcaption>
                        </figure>
                        <span className="bracket right"></span>
                    </div>
                </>
            )
        case 'press_quote_component':
            const link = ProcessLink(quote.article_link)
            return (
                <>
                    <div className="slide-inner press">
                        <figure className="quote-content">
                            <span className="bracket left"></span>
                            <blockquote>
                                &ldquo;
                                {quote.quote_text}
                                &rdquo;
                            </blockquote>
                            <figcaption>
                                {typeof quote.author_company !== 'undefined' &&
                                    <span className="company">{quote.author_company}</span>
                                }
                                {typeof quote.quote_date !== 'undefined' &&
                                    <span className="date">{new Date(quote.quote_date).toLocaleDateString('en-us', { day: "numeric", year: "numeric", month: "short" })}</span>
                                }
                            </figcaption>
                            <span className="bracket right"></span>
                        </figure>
                    </div>
                    {typeof quote.article_link !== 'undefined' &&
                        <div className="cta-container">
                            <a href={link.url} data-fancybox={link.dataFancybox} data-src={typeof link.modalId !== undefined ? "#" + link.modalId : null} target={link.target} rel={link.rel} title="Learn More" className={"cta-banner-link button secondary " + link.cssClass} >
                                <span>Learn More</span>
                                <div className='btn-bg top'></div>
                                <div className='btn-bg bottom'></div>
                            </a>
                        </div>
                    }
                </>
            )
        default:
    }
}

const Quote = ({ blok }) => {

    const quotes = blok.quote_items;

    return (
        <section className={"block_quote content_block" + ((blok.collapse_top_padding) ? ' collapse-top' : '') + ((blok.collapse_bottom_padding) ? ' collapse-bottom' : '')} {...storyblokEditable(blok)} key={blok._uid}>
        <Background blok={blok.background_settings} />
            <div className="inner">
            <BeforeContent blok={blok.before_content} />
                <div className="slider-wrapper gs_reveal">
                    <Swiper
                        spaceBetween={60}
                        slidesPerView="auto"
                        navigation={true}
                        modules={[Navigation]}
                    >
                        {quotes?.map(quote => (
                            <SwiperSlide key={quote._uid}>
                                <QuoteComponent quote={quote} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            <AfterContent blok={blok.after_content} />
            </div>
        </section>
    )
};

export default Quote;